import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/* Ant Design Vue */
import Antd, { message, Modal } from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'   // 一定要引入
dayjs.locale('zh-cn')         // 全局切到中文
/* Element Plus */
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'   // 核心样式

const app = createApp(App)

app
  .use(store)
  .use(router)
  .use(Antd)
  .use(ElementPlus)

// Element Plus 会覆盖 $message / $confirm，项目业务代码使用的是 ant-design-vue API，需恢复
app.config.globalProperties.$message = message
app.config.globalProperties.$confirm = Modal.confirm

app.mount('#app')